import React, { useContext, useEffect, useRef, useState } from "react";
import AddressArea from "./AddressArea";
import Breadcrumb from "../Generic/Breadcrumb";
import ContactForm from "./ContactForm";
import { ClipLoader } from "react-spinners";
import { getContactUsDetails } from "../Redux/API";
import { AppContext } from "../Redux/ContextProvider";

const Contact = () => {
    const { appState, dispatch } = useContext(AppContext);
    const { contact, contactLoader } = appState;
    const myRef = useRef(null);
    useEffect(() => {
        getContactUsDetails(appState, dispatch)
    }, [])

    return (
        <>
            {
                contactLoader ?
                    <div className='home-spinner'>
                        <ClipLoader color={"#2A5350"} loading={true} size={60} />
                    </div>
                    :
                    Object.keys(contact).length &&
                    <>
                        <Breadcrumb
                            pageName={contact.header_contact_section.title || "contact us"}
                            pageTitle={contact.header_contact_section.title || "contact us"}
                            id={`#${contact.header_contact_section.title}`}
                            image={contact.header_contact_section.banner_image}
                            myRef={myRef}
                        />
                        <div className="container">
                            <div className="glass-effect space">
                                <div className=" mb-50">
                                    <div ref={myRef} className="row">
                                        <AddressArea
                                            contact={contact.contact_section}
                                            locations={contact.location_list}
                                        />
                                        <ContactForm
                                            contact={contact.other_contact_section}
                                            contact_question_option={contact.contact_question_option}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }
        </>
    );
}

export default Contact;